module.exports = __webpack_public_path__ + "img/rate3.9d0e7080.png";